import { useModuleBEM } from "@b2bportal/core-themes";
import { InputContainer } from "@tenant/ui";
import clsx from "clsx";
import styles from "./InputButton.module.scss";

export const InputButton = ({
  icon,
  title,
  className,
}: {
  icon: React.ReactNode;
  title: string;
  className: string;
}) => {
  const [_block, cn] = useModuleBEM(styles, "InputButton");
  return (
    <InputContainer id={title} className={cn("input-container")}>
      <div className={clsx(cn("button-content"), className)}>
        <div className={cn("title")}>{title}</div>
        <div className={cn("icon")}>{icon}</div>
      </div>
    </InputContainer>
  );
};
